'use client';

import { createContext, useContext, ReactNode } from 'react';
import { PRISMIC_ZONE_LAYOUT } from '@/app/constants/zone';

type ZoneLayoutContextType = {
    layout: PRISMIC_ZONE_LAYOUT;
};

const ZoneLayoutContext = createContext<ZoneLayoutContextType | undefined>(undefined);

export const ZoneLayoutProvider = ({ layout, children }: { layout: PRISMIC_ZONE_LAYOUT; children: ReactNode }) => {
    return <ZoneLayoutContext.Provider value={{ layout }}>{children}</ZoneLayoutContext.Provider>;
};

export const useZoneLayout = () => {
    return useContext(ZoneLayoutContext);
};
